import { render, staticRenderFns } from "./ServicePointDetailBalance.vue?vue&type=template&id=13cec35d&scoped=true&"
import script from "./ServicePointDetailBalance.vue?vue&type=script&lang=ts&"
export * from "./ServicePointDetailBalance.vue?vue&type=script&lang=ts&"
import style0 from "./ServicePointDetailBalance.vue?vue&type=style&index=0&id=13cec35d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13cec35d",
  null
  
)

export default component.exports